export default __webpack_public_path__ + "static/media/static_img_commonroad_logo_white.811dccad.svg";